import React from 'react';
import ScTextAreaControl from '@/components/sc-controls/form-controls/v2/ScTextAreaControl';
import { FieldProps } from '../form-helpers';

export type FormFieldLongTextProps = Omit<FieldProps, 'value' | 'onChange'> & {
    value: string;
    onChange: (value: string) => void;
};

function FormFieldLongText({ label, required, value, onChange, onBlur, error, disabled, inTable }: FormFieldLongTextProps) {
    return (
        <ScTextAreaControl
            label={label}
            required={required}
            value={value ?? ''}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.currentTarget.value)}
            onBlur={onBlur}
            error={error}
            disabled={disabled}
            maw={inTable ? '100%' : undefined}
            minRows={2}
            autosize
            resize={inTable ? 'vertical' : 'both'}
            maxRows={inTable ? 5 : 8}
        />
    );
}

export default React.memo(FormFieldLongText);
